// extracted by mini-css-extract-plugin
export default {"auth_container":"style_auth_container__54MNE","auth_form":"style_auth_form__6DqgQ","form_control":"style_form_control__UhPsf","button":"style_button__Bu+2G"};